import React from 'react';

import commonStyle from 'commonStyle';
import { FaTimesCircle } from 'react-icons/fa'
import './index.css';
import Button from "components/Button";
import TruncateLine from "components/TruncateLine";
import Spacer from "components/Spacer";
import Table from "components/Table/Table";
import { formatter } from 'utils';


export default class FullDownload extends React.Component {
  renderLoading = (progress, cancelled) => (
    <div style={{ zIndex: 0, height: '100%', width: `${progress}%`, backgroundColor: cancelled ? 'rgba(255, 0, 0, 0.63)' : 'rgba(150, 191, 148, 0.63)', position: 'absolute', top: 0, bottom: -20, left: 0, right: 0 }} />
  )

  extractFiles = (ids = [], files = {}) => ids.map(id => files[id])

  getColumns = () => {
    return [
      {
        accessor: 'name',
        Cell: (props) => {
          const file = Object.values(props.original)[0];
          const _file = file.file;
          const isDone = file.cancelled || file.failed || file.uploaded;

          return (
            <div
              key={file.id}
              className={'uploader-full-tr'}
            >
              <div className={'uploader-full-tr-container'}>
                <div className={'uploader-full-table-col'}>
                  <div className={'upload-full-title'}>
                    <h5>
                      {_file.name}
                    </h5>
                  </div>
                </div>
                <div className={'uploader-full-table-col uploader-full-table-size'}>
                  <h5>
                    {formatter.memorySizeFormatter(_file.size)}
                  </h5>
                </div>
                <div className={'uploader-full-table-col uploader-full-table-cancel'}>
                  {
                    !isDone &&
                    <h5
                      onClick={() => {
                        if (file.cancelUploadSource) {
                          file.cancelUploadSource.cancel();
                        }
                      }}>
                      <FaTimesCircle/>
                    </h5> 
                  }
                  </div>
                
              </div>
              {this.renderLoading(file.progress, file.cancelled || file.failed)}
            </div>
          )
        }
      }
    ]
  }

  render() {
    const { files = {}, toggleView, onClearDownloaded } = this.props;

    const preparedFiles = Object.keys(files).map(key => ({ [key]: files[key] }))

    const singleFile = preparedFiles.length === 1;

    return (
      <div
        className={'uploader-container-full'}
        onClick={toggleView}
      >
        <div
          className={'uploader-full-table-container'}
          onClick={event => event.stopPropagation()}
        >
          <div
            style={{
              padding: 20
            }}
          >
            <h6>Uploading {singleFile ? 'File' : 'Files' }</h6>

            <Spacer />

            <Table
              bodyHeight={300}
              columns={this.getColumns()}
              data={preparedFiles}
              hideHeader
            />
         </div>
          <div
            className={'uploader-full-action-container'}
          >
            <Button onClick={onClearDownloaded} className={'uploader-full-action-button'}> Clear finished files </Button>
            <Button onClick={toggleView} className={'uploader-full-action-button'}> Hide </Button>
          </div>
        </div>
      </div>
    )
  }
}